import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';
import {getLabelFactory} from '@/modules/business-plan/modules/models/utils';
import {SaleType} from '@/modules/business-plan/modules/models/constants/saleType';

export const salesTypes: SaleType[] = [
  {
    initials: 'BusinessPlan.SalesTypes.RetailSales',
    text: 'BusinessPlan.SalesTypes.RetailSales',
    value: SaleTypeEnum.RetailSales,
    isAllSalesTypes: true,
    isShow: false
  },
  {
    initials: 'BusinessPlan.SalesTypes.DirectSalesInitials',
    text: 'BusinessPlan.SalesTypes.DirectSales',
    value: SaleTypeEnum.DirectSales,
    isAllSalesTypes: true,
    isShow: false
  },
  {
    initials: 'Common.Total',
    text: 'BusinessPlan.SalesTypes.AllSales',
    value: SaleTypeEnum.AllOfIt,
    isAllSalesTypes: false,
    isShow: true
  }
];
export const labelSalesType = getLabelFactory(salesTypes);
